import { v4 as uuidv4 } from 'uuid';

export const COMMAND_STATUS_POLL_INITIAL_DELAY_MS = 2_000;
export const COMMAND_STATUS_POLL_MAX_DELAY_MS = 30_000;
export const COMMAND_STATUS_POLL_MAX_TRANSIENT_FAILURES = 6;

export interface PendingFeedbackCommand {
    scope: string;
    fingerprint: string;
    commandId: string;
}

export function getOrCreateFeedbackCommand(
    current: PendingFeedbackCommand | null,
    scope: string,
    fingerprint: string,
): PendingFeedbackCommand {
    if (current?.scope === scope && current.fingerprint === fingerprint) return current;
    return { scope, fingerprint, commandId: uuidv4() };
}

export function commandWasDefinitivelyRejected(error: unknown): boolean {
    const status = Number((error as { response?: { status?: unknown } })?.response?.status);
    return Number.isInteger(status) && status >= 400 && status < 500 && status !== 408 && status !== 429;
}

export function commandStatusPollDelay(transientFailureCount: number): number {
    const exponent = Math.max(0, Math.floor(transientFailureCount));
    return Math.min(
        COMMAND_STATUS_POLL_MAX_DELAY_MS,
        COMMAND_STATUS_POLL_INITIAL_DELAY_MS * 2 ** exponent,
    );
}
